import React from 'react'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import { RulesProvider } from './context/RulesProvider'
import { RulesWorkflowsProvider } from './context/RulesWorkflowsProvider'
import { RulesMain } from './components/RulesMain'
import { CreateRuleFlow } from './workflows/CreateRuleFlow'

export const Rules = () => {
  return (
    <NuqsAdapter>
      <RulesProvider>
        <RulesWorkflowsProvider>
          <RulesMain />
          <CreateRuleFlow />
        </RulesWorkflowsProvider>
      </RulesProvider>
    </NuqsAdapter>
  )
}
